import React, {Component} from 'react';
import {connect} from 'react-redux';
import { dataLoad } from '../../redux/actions/autoCompleteActions';
import { diseaseCreate } from '../../redux/actions/settingActions/diseaseActions';
import { medicationCreate } from '../../redux/actions/settingActions/medicationActions';

var delayTimer;
class AutoComplete extends Component {
  constructor(props){
    super(props);
    this.state={data: [], search: ""};
  }

  handleFocus = () => {
    const {klass,rpp, otherFilters, additionalFilters, loadOnFocus, sort, direction} = this.props
    if (!loadOnFocus || !klass) return
    var filters = {search: "", rpp: rpp, klass: klass, ...otherFilters}
    if (sort) filters.sort = sort
    if (direction) filters.direction = direction
    if (additionalFilters) {
      filters = {...filters, filter: {...filters.filter, ...additionalFilters}}
    }
    this.props.dispatch(dataLoad(filters)).then(response => {
      this.setState({data: response.value.data.data})
    })
  }

  handleSearch(value) {
    const {klass,rpp, otherFilters, additionalFilters, sort, direction} = this.props
    this.setState({search: value})
    var filters = {search: value, rpp: rpp, klass: klass, ...otherFilters}
    if (sort) filters.sort = sort
    if (direction) filters.direction = direction
    if (klass) {
      clearTimeout(delayTimer)
      delayTimer = setTimeout(function() {
        new Promise((resolve, reject) => {
          if (additionalFilters) {
            filters = {...filters, filter: {...filters.filter, ...additionalFilters}}
          }
          this.props.dispatch(dataLoad(filters))
            .then(response => {
              this.setState({data: response.value.data.data})
            })
        })
      }.bind(this), 500)
    }
  }

  async handleAddNewSetting(){
    const { valueField, addNewSetting, settingImpressionId } = this.props
    var recordType = addNewSetting.split('family_').pop()
    if( recordType === "medical_history" || recordType ==="ocular_history" || recordType === "allergy" || recordType === "surgery" ){
      var res = await this.props.dispatch(diseaseCreate({disease_type: recordType, name: this.state.search.trim()}))
      this.handleSelect(res.value.data.disease[valueField])
    }else if(recordType === "medication"){
      var res = await this.props.dispatch(medicationCreate({ name: this.state.search.trim()}))
      this.handleSelect(res.value.data.medication[valueField])
    }
  }

  handleSelect(val) {
    this.props.onSelect(val)
    this.setState({search: "", data: []})
  }

  render(){
    const {placeholder, wrapperClasses, dropdownClasses, textField, valueField, addNewSetting, hideAddButton, loadOnFocus} = this.props
    const {data} = this.state
    return(
      <div className={`exam-template ${wrapperClasses} pointer`}>
        <div className="input-group">
          <input value={this.state.search} onFocus={loadOnFocus ? this.handleFocus : undefined} onBlur={() => setTimeout(() => this.setState({ data: [] }), 150)} onChange={(search) => this.handleSearch(search.target.value)} type="text" className="form-control pointer" placeholder={placeholder}/> 
          {
            addNewSetting && !hideAddButton && data && data.filter(entry => entry[textField].trim().toLowerCase() === this.state.search.trim().toLowerCase()) == 0 && this.state.search != "" ?
            <div className="input-group-append" onMouseDown={this.handleAddNewSetting.bind(this)}>
              <span className="input-group-text pointer position-static bg-primary text-white">Add</span>
            </div>
            :
            <div className="input-group-append">
              <span className="input-group-text search-button position-static bg-light"><i className="la la-search text-muted" /></span>
            </div>
          }
        </div>
        <ul className={`dropdown-menu list-unstyled bg-white w-100 ${dropdownClasses} ${data && data.length > 0 ? 'show' : ''}`}>
          {data?.map(obj => (
            <li key={`auto-complete ${valueField ? obj[valueField] : obj.id}`} className="dropdown-item pointer" onMouseDown={this.handleSelect.bind(this, valueField ? obj[valueField] : obj)}>
              <span className="text-wrap">{obj[textField]}</span>
            </li>            
          ))}
        </ul>
      </div>
    );
  }
}

export default connect()(AutoComplete);
